import { ErrorMessage } from "@hookform/error-message";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import { Button, Input, Table } from "reactstrap";
import { RSelect } from "../../components/Component";
import { INGREDIENT_PRICE_HISTORY_COMMISSION_TYPE } from "../../utils/Utils";

const INGREDIENT_PRICE_HISTORY_COMMISSION_TYPE_OPTIONS = Object.entries(INGREDIENT_PRICE_HISTORY_COMMISSION_TYPE).map(([value, label]) => ({
  label,
  value,
}));
export const IngredientPriceCommissionComponent = ({
  customerOptions = [],
}) => {
  const { errors, control, getValues } = useFormContext();
  const {
    fields: commissions,
    remove: removeBillCommissions,
    append: appendBillCommissions,
  } = useFieldArray({
    control,
    name: 'commissions',
  })

  return (
    <Table className="table table-bordered">
      <thead>
        <tr>
          <th>Loại<span className="text-danger">*</span></th>
          <th>Khách hàng</th>
          <th>Phí hoa hồng/kg<span className="text-danger">*</span></th>
          <th>Mô tả</th>
          <th>
            <Button
              color="primary"
              className="btn-sm"
              onClick={() => appendBillCommissions({
                customerId: null,
                commissionFeePerWeight: null,
              })}
            >
              Thêm
            </Button>
          </th>
        </tr>
      </thead>
      <tbody>
        {commissions.map((commission, index) => (
          <tr key={index}>
            <td>
              <Controller
                defaultValue={commission?.type}
                control={control}
                name={`commissions.${index}.type`}
                rules={{
                  required: "Vui lòng nhập thông tin",
                }}
                render={({ onChange, value, name, ref }) => (
                  <RSelect
                    ref={ref}
                    name={name}
                    options={INGREDIENT_PRICE_HISTORY_COMMISSION_TYPE_OPTIONS}
                    value={
                      INGREDIENT_PRICE_HISTORY_COMMISSION_TYPE_OPTIONS.find((c) => c.value === value) || null
                    }
                    onChange={(val) => {
                      onChange(val.value);
                    }}
                  />
                )}
              />
              <ErrorMessage
                errors={errors}
                name={`commissions.${index}.type`}
                render={({ message }) => (
                  <span className="invalid">{message}</span>
                )}
              />
            </td>
            <td>
              <Controller
                defaultValue={commission?.customerId}
                control={control}
                name={`commissions.${index}.customerId`}
                render={({ onChange, value, name, ref }) => (
                  <RSelect
                    ref={ref}
                    name={name}
                    options={customerOptions}
                    value={
                      customerOptions.find((c) => c.value === value) || null
                    }
                    onChange={(val) => {
                      onChange(val.value);
                    }}
                  />
                )}
              />
              <ErrorMessage
                errors={errors}
                name={`commissions.${index}.customerId`}
                render={({ message }) => (
                  <span className="invalid">{message}</span>
                )}
              />
            </td>
            <td>
              <Controller
                control={control}
                name={`commissions.${index}.commissionFeePerWeight`}
                rules={{ required: "Vui lòng nhập thông tin" }}
                defaultValue={commission?.commissionFeePerWeight}
                render={({ onChange, value, ref }) => (
                  <NumericFormat
                    className="form-control"
                    getInputRef={ref}
                    type="text"
                    value={value}
                    thousandsGroupStyle="thousand"
                    thousandSeparator=","
                    decimalScale={0}
                    onValueChange={(val) => onChange(val.floatValue)}
                  />
                )}
              />
              <ErrorMessage
                errors={errors}
                name={`commissions.${index}.commissionFeePerWeight`}
                render={({ message }) => (
                  <span className="invalid">{message}</span>
                )}
              />
            </td>
            <td>
              <Controller
                control={control}
                name={`commissions.${index}.description`}
                defaultValue={commission?.description}
                render={({ onChange, value }) => (
                  <Input type="text" value={value} onChange={(e) => onChange(e.target.value)} />
                )}
              />
            </td>


            <td>
              <Button
                color="danger"
                className="btn-sm"
                onClick={() => removeBillCommissions(index)}
              >
                Xóa
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};